import data from './countries.json';

export default data.map(({flag, name, alpha2Code, alpha3Code, callingCodes}: any) => ({
    flag,
    name,
    alpha2Code,
    label: `+${callingCodes[0]} (${alpha2Code})`,
    value: `+${callingCodes[0]}|${alpha2Code}`
}));
